import { InformativeModal } from "@vega-core/components/Modals/InformativeModal/InformativeModal";
import { m } from "@vega-core/paraglide/messages";

type UnsavedChangesModalProps = {
  isBlocked: boolean;
  proceed: () => void;
  cancel: () => void;
};

export function UnsavedChangesModal({
  isBlocked,
  proceed,
  cancel,
}: UnsavedChangesModalProps) {
  return (
    <InformativeModal
      description={m.common_unsavedChanges_description()}
      isOpen={isBlocked}
      onClose={cancel}
      primaryBtnProps={{
        children: m.common_unsavedChanges_leave(),
        onClick: proceed,
        variant: "destructive",
      }}
      secondaryBtnProps={{
        children: m.common_unsavedChanges_stay(),
        onClick: cancel,
      }}
      title={m.common_unsavedChanges_title()}
      variant="error"
    />
  );
}
